import {
    LockOutlined
} from "@ant-design/icons";
import { Button, Form, Input, Typography } from "antd";
import { useAxiosRequest } from "common/hooks";
import { useTranslation } from "react-i18next";
import { shallowEqual, useSelector } from "react-redux";
const ChangePassword = () => {
    const {t} = useTranslation();
    const { profileData, originalTokenData } = useSelector((state: any) => state.auth, shallowEqual);
    // Always change the real logged-in user's password, even while acting as another account.
    const realEmail = originalTokenData?.emailaddress ?? profileData?.tokenData?.emailaddress;
    const putPassword = useAxiosRequest('')
    const [form] = Form.useForm()
    const onFinishPassword = (values: any) => {
        putPassword.apiAction({
            urlObjKey: 'ChangePassword',
            method: 'PUT',
            params: {
                email: realEmail,
                newPassword: values?.createPassword,
                currentPass: values?.currentPassword,
            },
            isToast: true,
            useOriginalToken: true,
            cb: () => {
                form.resetFields();
            },
            onError: () => {
            },
        });

    }
    return (

        <Form
            onFinish={onFinishPassword}
            requiredMark={false}
            layout="vertical"
            form={form}
        >
            <Form.Item
                name="currentPassword"
                label={
                    <Typography.Title style={{margin:0}}  className=' !text-md !font-bold'>
                        {t('settings:changePassword:currentPassword')}
                        <span style={{ color: 'red', marginLeft: 3 }}>*</span>
                    </Typography.Title>
                }
                rules={[
                    { required: true, message: t('settings:changePassword:currentPasswordRequired') },
                ]}
            >
                <Input.Password
                    placeholder= {t('settings:changePassword:currentPasswordPlaceholder')}
                    prefix={
                        <LockOutlined className="site-form-item-icon mr-1 text-gray-500" />
                    } />
            </Form.Item>
            <Form.Item
                label={
                    <Typography.Title style={{margin:0}}  className=' !text-md !font-bold'>
                      {t('settings:changePassword:newPassword')}
                        <span style={{ color: 'red', marginLeft: 3 }}>*</span>
                    </Typography.Title>
                }
                name="createPassword"
                className="mb-6 md:mb-2"
                rules={[
                    { required: true, message:  t('settings:changePassword:newPasswordRequired'), validateTrigger: 'onSubmit' },
                    { min: 6, message: t('settings:changePassword:newPasswordRequiredMin'), validateTrigger: 'onChange' },
                    {
                        pattern: /^(?=.*\d)/,
                        message: t('settings:changePassword:newPasswordRequiredNum'),
                        validateTrigger: 'onChange',
                    },
                    {
                        pattern: /^(?=.*[A-Z])/,
                        message: t('settings:changePassword:newPasswordRequiredUp'),
                        validateTrigger: 'onChange',
                    },
                    {
                        pattern: /^(?=.*[a-z])/,
                        message: t('settings:changePassword:newPasswordRequiredLow'),
                        validateTrigger: 'onChange',
                    },
                    {
                        pattern: /^(?=.*[@$#!%?&])/,
                        message: t('settings:changePassword:newPasswordRequiredSep'),
                        validateTrigger: 'onChange',
                    },
                ]}
                validateFirst={true}
                hasFeedback
            >
                <Input.Password
                    placeholder={t('settings:changePassword:newPasswordPlaceholder')}
                    prefix={
                        <LockOutlined className="site-form-item-icon mr-1 text-gray-500" />
                    }
                />
            </Form.Item>
            <Form.Item
                label={
                
                     <Typography.Title style={{margin:0}}  className=' !text-md !font-bold'>
                       {t('settings:changePassword:repeatPassword')}
                        <span style={{ color: 'red', marginLeft: 3 }}>*</span>
                    </Typography.Title>
                }
                name="confirmPassword"
                className="mb-6 md:mb-2"
                dependencies={['createPassword']}
                rules={[
                    { required: true, message: t('settings:changePassword:repeatPasswordRequired') },
                    ({ getFieldValue }) => ({
                        validator: (_, value) => {
                            if (!value || getFieldValue('createPassword') === value) {
                                return Promise.resolve();
                            }
                            return Promise.reject(t('settings:changePassword:repeatPasswordMatch'));
                        },
                    }),
                ]}
                hasFeedback
            >
                <Input.Password
                    placeholder={t('settings:changePassword:repeatPasswordPlaceholder')}
                    prefix={
                        <LockOutlined className="site-form-item-icon mr-1 text-gray-500" />
                    }
                />
            </Form.Item>
            <Form.Item>
                <Button type="primary" htmlType="submit"
                    className="bg-primaryColor  h-9  font-bold text-[#FFFFFF] rounded-[8px]"
                    loading={putPassword.isLoading}
                >
                    {
                        putPassword.isLoading ? t('settings:changePassword:upadating') : t('settings:changePassword:updatePassword')
                    }
                </Button>
            </Form.Item>
        </Form>
    );
};

export default ChangePassword;